import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/sections/CTASection.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/sections/ExportCapabilitiesSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/sections/HeroSection.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/sections/IndustriesSection.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/sections/OurWorkSection.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/sections/TestimonialsSection.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/sections/WhyChooseSection.jsx");
